const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaBooleanCtrl = function ($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  
  if (vm.settings.notNullable && vm.data == null) {
    _.set(dataService.data.activeItem, dataLookUp, false)
  }

  $scope.$watchCollection('vm.data', function (newData, oldData) {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });
};

lbaBooleanCtrl.$inject = $inject;

export default lbaBooleanCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaBoolean/lbaBooleanCtrl.js